module.exports = __webpack_public_path__ + "img/exclamation.65a3c2e6.svg";